

















































































import { Component, Vue } from 'vue-property-decorator'
import Gallery from '@/components/Gallery.vue'
import Frame from '@/components/Frame.vue'
import { Section, Image } from '@/types'

@Component({
  components: {
    Frame,
    Gallery,
  },
})
export default class Home extends Vue {
  sections: Section[] = []
  galleryImages: Image[] = []
  galleryIndex: number | null = null
  loading: boolean = true
  error: string | null = null

  // Number of images considered "above the fold" (first screen)
  private readonly ABOVE_FOLD_COUNT: number = 8

  async created() {
    await this.fetchSections()
  }

  mounted() {
    window.addEventListener('hashchange', this.openFromHash)
  }

  beforeDestroy() {
    window.removeEventListener('hashchange', this.openFromHash)
  }

  async fetchSections() {
    this.loading = true
    this.error = null
    try {
      const response = await fetch('/photos/index.json')
      if (!response.ok) {
        throw new Error(`index.json responded ${response.status}`)
      }
      this.sections = await response.json()
      this.openFromHash()
    } catch (err) {
      this.error = 'Failed to load photos. Please check your network connection.'
      console.error('Failed to fetch sections:', err)
    } finally {
      this.loading = false
    }
  }

  // Get global index of an image across all sections
  getGlobalIndex(section: Section, localIndex: number): number {
    let globalIndex = 0
    for (const s of this.sections) {
      if (s === section) {
        return globalIndex + localIndex
      }
      globalIndex += s.images.length
    }
    return globalIndex + localIndex
  }

  // Check if image is in the first screen (above the fold)
  isAboveFold(globalIndex: number): boolean {
    return globalIndex < this.ABOVE_FOLD_COUNT
  }

  openGallery(section: Section, index: number) {
    this.galleryImages = section.images
    this.galleryIndex = index
    history.replaceState(null, '', `#${encodeURIComponent(section.slug)}/${index}`)
  }

  closeGallery() {
    this.galleryIndex = null
    history.replaceState(null, '', window.location.pathname + window.location.search)
  }

  // 支持 #<目录名>/<序号> 直接分享到某一张
  openFromHash() {
    const [slug, index] = decodeURIComponent(window.location.hash.slice(1)).split('/')
    const section = this.sections.find(item => item.slug === slug)
    const imageIndex = Number(index)
    if (!section || !Number.isInteger(imageIndex) || !section.images[imageIndex]) {
      this.galleryIndex = null
      return
    }
    this.galleryImages = section.images
    this.galleryIndex = imageIndex
  }
}
